import {Outlet, Link, useRoutes,useLoaderData} from "react-router-dom";
import routes from "../routes/routes";

import { getContacts } from "../data/contacts";

import { useAuth } from "react-oidc-context";
import React, {useState} from "react";

import "../index.css";


// router tutorial
//
// https://reactrouter.com/en/main/start/tutorial
//
//

const RootLayout = ()  =>  {

    const auth = useAuth();

    const [timeout,setTimeout] = useState(0)




    React.useEffect(() => {
        // the `return` is important - addAccessTokenExpiring() returns a cleanup function
        return auth.events.addAccessTokenExpiring(() => {
            //if (alert("You're about to be signed out due to inactivity. Press continue to stay signed in.")) {
            //    auth.signinSilent();
            //}
            //auth.removeUser();

            setTimeout(timeout + 1);

            console.log("micae:refresh token ? :"+timeout);
//            if (timeout < 1  ) {
            if (false ) {
                console.log("micae:refresh token");
                auth.signinSilent();
            } else {
                console.log("micae: end session");
                auth.removeUser();
                setTimeout(0);
                window.location.replace(process.env.PUBLIC_URL);
            }

        })
    }, [auth.events, auth.signinSilent]);


    const { contacts } = useLoaderData();

    return (
        <>
            <div id="sidebar">
                <h1>FCHPT / SCHK self services</h1>
                <div>
                    {/*
                    <form id="search-form" role="search">
                        <input
                            id="q"
                            aria-label="Search contacts"
                            placeholder="Search"
                            type="search"
                            name="q"
                        />
                        <div
                            id="search-spinner"
                            aria-hidden
                            hidden={true}
                        />
                        <div
                            className="sr-only"
                            aria-live="polite"
                        ></div>
                    </form>
                    <form method="post">
                        <button type="submit">New</button>
                    </form>
                    */}
                </div>
                <nav>
                    <ul>
                        <li>
                            <Link to={process.env.PUBLIC_URL}>Home</Link>
                        </li>


                        {  (auth && auth.isAuthenticated)  ?  <li><Link to={process.env.PUBLIC_URL+"/passwords"}>Change Passwords</Link></li> : <div/> }

                        {/*
                        <li>
                            <Link to={process.env.PUBLIC_URL+"/contacts"}>Contacts</Link>
                        </li>
                        */}







                        {  (auth && auth.isAuthenticated)  ? <li><button onClick={() => {
                            auth.removeUser();
                            //localStorage.clear();
                            window.location.replace(process.env.PUBLIC_URL);
                            }
                        }>Log Out</button></li>  :  <li><button onClick={() => auth.signinRedirect()}>Log In</button></li>}

                    </ul>
                </nav>
                <nav>
                    {contacts.length ? (
                        <ul>
                            {contacts.map((contact) => (
                                <li key={contact.id}>
                                    <Link to={`contacts/${contact.id}`}>
                                        {contact.first || contact.last ? (
                                            <>
                                                {contact.first} {contact.last}
                                            </>
                                        ) : (
                                            <i>No Name</i>
                                        )}{" "}
                                        {contact.favorite && <span>★</span>}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p>
                            {/*
                            <i>No contacts</i>
                            */}
                        </p>
                    )}
                </nav>
            </div>





            <div id="detail"><Outlet /></div>


        </>
    );
}

export default RootLayout